import React from "react"
import VariableVersionIcon from "../../VariableVersionIcon/VariableVersionIcon"
import "./TopSection.scss"
import { TdsButton, TdsIcon } from "@scania/tegel-react"
import DropdownButton from "../DropdownButton/DropdownButton"
import { useFormContext } from "react-hook-form"

type TopSectionProps = {
  selectedVariableDetails?: VariableDetail
  clearSelectedVariable: () => void
  action: string
  setAction: (action: string) => void
  onUserAction: (userAction: string) => void
  isEditor: boolean
}

const TopSection = ({ selectedVariableDetails, clearSelectedVariable, isEditor, action, setAction, onUserAction }: TopSectionProps) => {

  const {reset} = useFormContext();

  const returnToReadOnly = () => {
    // reset();
    setAction('read');
    // clearSelectedVariable();
  }
  const onCloseClick = () => {
    reset();
    setAction('read');
  }

  const displayVariableStatusSpecificCTAButtons = (variableStatus: string | undefined) => {
    switch (variableStatus) {
      case 'Published':
        return (
          <>
            {action !== 'update' ? <span className="tds-u-gap2 tds-row">
              <DropdownButton
                label="Select update mode"
                options={['Update with version', 'Update w/o version']}
                onSelect={(option) => { onUserAction(option); setAction('update') }}
                buttonColor="mode"
              />
              <TdsButton type="submit" variant="danger" text="Deprecate " size="sm" onClick={() => { setAction('edit'); onUserAction('Deprecate'); }} />
            </span> : <span className="tds-u-gap2 tds-row">
              <TdsButton type="submit" variant="secondary" text="cancel " size="sm" onClick={() => { returnToReadOnly(); }} />
              {/* TODO: implement the save function on update with or w/o version  */}
              <TdsButton type="submit" variant="primary" text="Save" size="sm" onClick={() => { onUserAction('Save'); }} />
            </span>}
          </>
        )
      case 'Test':
        return (
          <>
            {action !== 'edit' ? <span className="tds-u-gap2 tds-row">
              <TdsButton variant="secondary" text="Edit " size="sm" onClick={() => { setAction('edit') }} />
              <TdsButton type="submit" variant="primary" text="Publish" size="sm" onClick={() => { setAction('edit'); onUserAction('Publish'); }} />
            </span> : <span className="tds-u-gap2 tds-row">
              <TdsButton variant="secondary" text="cancel " size="sm" onClick={() => { returnToReadOnly(); }} />
              <DropdownButton
                label="Select status"
                options={['Save as draft', 'Publish']}
                onSelect={(option) => { onUserAction(option); }}
                buttonColor="primary"
                behavior="submit" />
            </span>}
          </>
        )
      case 'Deprecated':
        return (
          <span className="tds-u-gap2 ">
          </span>
        )
      default:
        return (
          <>
            {action === "read" ? (
              <span className="tds-u-gap2 tds-row">
                <TdsButton
                  variant="secondary"
                  text="Edit "
                  size="sm"
                  onClick={() => {
                    setAction("edit");
                  }}
                />
                <TdsButton
                  variant="primary"
                  text="Move to test "
                  size="sm"
                  onClick={() => {
                    setAction("edit");
                    onUserAction("Move to test");
                  }}
                />
              </span>
            ) : (
              <span className="tds-u-gap2 tds-row">
                <TdsButton
                  variant="secondary"
                  text="cancel "
                  size="sm"
                  onClick={onCloseClick}
                />
                <DropdownButton
                  label="Select status"
                  options={["Save as draft", "Move to test"]}
                  onSelect={(option) => { onUserAction(option) }}
                  buttonColor="primary"
                  behavior="submit"
                />
              </span>
            )}
          </>
        );
    }

  }

  return (
    <>
      {action !== "create" && (
        <div>
          <div className="row">
            <span className="tds-u-gap2 left-aligned">
              <h5 className="blue-400">
                {" "}
                ID : {selectedVariableDetails?.id}{" "}
              </h5>
              <VariableVersionIcon
                version={`v${selectedVariableDetails?.version}`}
              />
              <h5 className="blue-400">
                {" "}
                Status : {selectedVariableDetails?.status}{" "}
              </h5>
            </span>
            <TdsButton
              type="button"
              className="right-aligned"
              variant="ghost"
              size="sm"
              onClick={onCloseClick}
            >
              <TdsIcon slot="icon" size="20px" name="cross" />
            </TdsButton>
          </div>
          <h3> {selectedVariableDetails?.name} </h3>

          <div className="row">
            <p>
              Last modified by{" "}
              <span className="blue-400">
                {selectedVariableDetails?.modifiedBy}
              </span>
            </p>
            {isEditor && (
              <div className="action-buttons right-aligned">
                {displayVariableStatusSpecificCTAButtons(
                  selectedVariableDetails?.status
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {action === "create" && (
        <div className="row tds-u-mb2">
          <h3> Create Variable </h3>
          <div className="action-buttons right-aligned">
            {displayVariableStatusSpecificCTAButtons(
              selectedVariableDetails?.status
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default TopSection